module.exports = __webpack_public_path__ + "img/splash_bg.16f2ac2a.jpg";